import { useEffect, useState } from 'react';
import { getAccountInfo } from '@fff-web/fff-utilities';

const useUserShippingAddress = () => {
  const [shippingAddress, setShippingAddress] = useState(null);

  useEffect(() => {
    // FP-1339: metadata-only read — only `shippingAddress`. No subscription
    // fields consumed, so this legacy call is retained as-is.
    getAccountInfo('dev').then(({ shippingAddress: sa }) => {
      setShippingAddress(sa);
    });
  }, []);

  return shippingAddress;
};

export default useUserShippingAddress;
